
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_xttbq_1ekiv_141"
};
  